import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration from environment variables
const env = (key) => (process.env[key] || '').trim();

const firebaseConfig = {
  apiKey: env('REACT_APP_FIREBASE_API_KEY'),
  authDomain: env('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  databaseURL: env('REACT_APP_FIREBASE_DATABASE_URL'),
  projectId: env('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: env('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('REACT_APP_FIREBASE_APP_ID'),
  measurementId: env('REACT_APP_FIREBASE_MEASUREMENT_ID')
};

// Validate required config
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error(
    'Firebase configuration is missing. Please check your .env file and ensure all REACT_APP_FIREBASE_* variables are set.'
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;